import { useOutletContext } from "react-router";

export interface ProjectScope {
  tenant: string;
  project: string;
  role: string;
  /** Qui peut clore une tâche : pull_request_merged | human | any. */
  donePolicy: string;
  /** Brain d'organisation du tenant (PB-112) : sa connaissance est héritée par tous les projets. */
  org?: boolean;
}

/** Projet courant, fourni par ProjectLayout. */
export function useScope(): ProjectScope {
  return useOutletContext<ProjectScope>();
}

export const canMaintain = (role: string) => role === "maintainer" || role === "owner";
